import {get, post, put,postJson, deleteData} from '@/utils/fetch';
// 机构列表
export function getOrgList(data) {
	return get({
		url: 'manage/sys/org',
		data
	})
}
// 机构行政区域
export function getOrgArea(data) {
	return get({
		url: 'manage/sys/org/getOrgInfo',
		data
	})
}
// 删除之前的查询机构子级
export function preRemoveOrgs(data) {
	return post({
		url: 'manage/sys/org/pre-delete',
		data
	})
}
// 删除机构
export function removeOrgs(data) {
	return postJson({
		url: 'manage/sys/org/delete',
		data
	})
}
// 检验机构名
export function checkOrgName(data) {
	return get({
		url: 'manage/sys/org/check/name',
		data
	})
}
// 检验机构ID
export function checkOrgId(data) {
	return get({
		url: 'manage/sys/org/check/ids',
		data
	})
}
// 新增机构
export function saveOrg(data) {
	return post({
		url: 'manage/sys/org',
		data
	})
}
// 机构审核
export function reviewOrg(data) {
	return post({
		url: 'manage/sys/org/review',
		data
	})
}


// 学校列表
export function getSchoolList(data) {
	return get({
		url: 'manage/sys/school',
		data
	})
}
// 检验学校名
export function checkSchName(data) {
	return get({
		url: 'manage/sys/org/check/name',
		data
	})
}
// 新增学校
export function saveSchool(data) {
	return post({
		url: 'manage/sys/school',
		data
	})
}
// 删除学校
export function removeSchs(data) {
	return deleteData({
		url: 'manage/sys/school',
		data
	})
}
// 是否有学区可选
export function hasSchoolDistrict(data) {
	return get({
		url: 'manage/sys/school/selectOrgOfSchool',
		data
	})
}
// 学校审核
export function reviewSchool(data) {
  return post({
    url: 'manage/sys/school/review',
    data
  })
}

// 历次导入错误
export function getImportError(data) {
	return get({
		url: 'manage/sys/org/qurey/batch',
		data
	})
}
// 权限详情
export function getAuthDetail(data) {
	return get({
		url: 'manage/sys/role/getUserMenuList',
		data
	})
}

// 学校授权，获取已有权限
export function getAuth(data) {
	return get({
		url: 'manage/sys/org/getOrgMenuTree',
		data
	})
}
// 设置权限
export function saveAuth(data) {
	return post({
		url: 'manage/sys/org/addOrgMenu',
		data
	})
}

// 查找转辖区机构
export function getParentOrgList(data) {
  return get({
    url: 'manage//pub/getParentOrgList',
    data
  })
}
// 学校转辖区
export function changeSchoolHigher(data) {
  return post({
    url: 'manage/sys/org/changeSchoolHigher',
    data
  })
}

// 学校信息
export function querySchoolInfo(data) {
  return get({
    url: 'manage/sys/school/querySchoolInfo',
    data
  })
}
// 更新学校信息
export function updateSchoolInfo(data) {
  return post({
    url: 'manage/sys/school/updateSchoolInfo',
    data
  })
}
// 获取班级列表
export function getSchoolClass(data) {
  return get({
    url: 'manage/sys/schoolClass',
    data
  })
}
// 新增班级
export function updateSchoolClass(data) {
  return put({
    url: 'manage/sys/schoolClass/update?' + data,
  })
}
// 批量新增班级
export function addBatchClass(data) {
  return put({
    url: 'manage/sys/schoolClass/addClass?' + data
  })
}
// 删除班级
export function deleteClass(data) {
  return deleteData({
    url: 'manage/sys/schoolClass/' + data,
  })
}



// WEBPACK FOOTER //
// ./src/api/organization.js